// extracted by mini-css-extract-plugin
export default {"container":"CreateBlog_container__UouLc","btn":"CreateBlog_btn__ntLOj"};